'use client';

import { Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useStyles } from './style';
import Utterance from './Utterance';

/**
 * @name UtteranceTiles
 * @param {object} props - Strapi Data
 * @returns {JSX.Element} - Renders Utterance Tiles component
 */
const UtteranceTiles = props => {
  const theme = useTheme();
  const style = useStyles(theme);
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Grid
        container
        direction='row'
        spacing={sm ? 0 : 1}
        maxWidth='lg'
        justifyContent='center'
        sx={style.tilesContainer}
      >
        {props?.cmsData?.Utterances?.map(data => (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={props?.cmsData?.Utterances?.length === 1 ? 12 : 6}
            key={data?.id}
            sx={style.utteranceList}
          >
            <Typography variant='h2' sx={style.serviceTitle}>
              {data?.serviceTitle}
            </Typography>
            <Typography variant='body1' sx={style.serviceSubTitle}>
              {data?.serviceSubTitle}
            </Typography>
            <Stack
              direction={props?.cmsData?.Utterances?.length === 1 ? 'row' : 'column'}
              justifyContent='center'
            >
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 5 }}>
                {data?.utterance?.map(element => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={props?.cmsData?.Utterances?.length === 1 ? 6 : 12}
                    key={element?.id}
                  >
                    <Utterance
                      {...element}
                      key={element?.id}
                      tileIcon={props?.cmsData.tileArrowIcon}
                      tileHoverIcon={props?.cmsData?.tileArrowHoverIcon}
                      utteranceLength={props?.cmsData?.Utterances?.length}
                      showLoginVerificationModal={props?.showLoginVerificationModal}
                      sweeprParams={props?.sweeprParams}
                      setSweeprParams={props?.setSweeprParams}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

UtteranceTiles.displayName = 'UtteranceTiles';
export default UtteranceTiles;
